<div class="panel-form">
  <form class="panel-form__form">
    <div class="panel-form__form__header">
      <span *ngIf="!ui.editMode; else editModeTitle" class="panel-form__form__header__title">
        {{ panelDef.title }}
      </span>
      <ng-template #editModeTitle>
        <div class="panel-form__form__header__title-edit">
          <mat-form-field>
            <input matInput [formControl]="title" placeholder="Panel title" autocomplete="off" />
          </mat-form-field>
        </div>
      </ng-template>
      <div class="panel-form__form__header__actions">
        @if (!readonly && hasPendingChanges()) {
          <div>
            <ts-button
              type="stroked"
              color="accent"
              class="mr-2"
              [disabled]="savingChanges()"
              (click)="discardChanges()"
              >Discard
            </ts-button>
            <ts-button [loading]="savingChanges()" [debounceTime]="500" (click)="saveChanges()"
              >Save changes
            </ts-button>
          </div>
        }
        <button mat-icon-button type="button" *ngIf="!ui.editMode && canEditLayout" [matMenuTriggerFor]="moreMenu">
          <mat-icon class="icon-size-20" svgIcon="more_vert"></mat-icon>
        </button>
        <mat-menu #moreMenu>
          <button mat-menu-item (click)="toggleEditMode()" type="button">
            <mat-icon svgIcon="edit"></mat-icon>
            Edit Layout
          </button>
        </mat-menu>
        <div class="panel-form__form__header__actions__layout" *ngIf="ui.editMode">
          <button mat-icon-button type="button" matTooltip="Cancel" (click)="cancelEdits()">
            <mat-icon svgIcon="cancel"></mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            *ngIf="!panelDef.meta.fields?.length"
            matTooltip="Add Row"
            #addContactPanelOrigin
            (click)="manageField('first')"
          >
            <mat-icon svgIcon="add_circle"></mat-icon>
          </button>
          <button mat-icon-button type="button" (click)="saveLayout()" matTooltip="Save">
            <mat-icon svgIcon="save"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="panel-form__form__body">
      <ng-container *ngIf="!ui.editMode; else fieldsEditMode">
        <div class="panel-form__form__body__row" *ngFor="let fieldRow of panelDef.meta.fields; let lastRow = last">
          <ng-container *ngFor="let fieldName of fieldRow">
            <ng-container *ngIf="lookupField(fieldName) as fieldDef">
              <app-form-field
                #fields
                [fieldDef]="fieldDef"
                [model]="model"
                (onUpdate)="update($event)"
                [data]="data"
                [readonly]="fieldDef.meta?.readonly || readonly"
              ></app-form-field>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #fieldsEditMode>
        <ng-container>
          <div class="panel-form__form__body__edit-fields" cdkDropListGroup>
            <div
              class="panel-form__form__body__edit-fields__row"
              *ngFor="
                let fieldRow of panelDef.meta.fields;
                let rowIndex = index;
                let firstRow = first;
                let lastRow = last
              "
              cdkDropList
              [cdkDropListData]="fieldRow"
              (cdkDropListDropped)="dropped($event)"
              cdkDropListOrientation="horizontal"
            >
              <div
                class="panel-form__form__body__edit-fields__row__col"
                cdkDrag
                *ngFor="let fieldName of fieldRow; let colIndex = index; let firstCol = first; let lastCol = last"
              >
                <ng-container dynamicFormRow elmType="select-field" [baseClassNames]="'flex flex-col'">
                  <ng-container *ngIf="lookupField(fieldName) as fieldDef">
                    <mat-icon class="drag-handler" svgIcon="drag_indicator" matTooltip="Drag me" cdkDragHandle>
                    </mat-icon>
                    <select-field
                      [data]="{ fieldDefs }"
                      class="flex flex-col select-field"
                      [fieldDef]="fieldDef"
                      [model]="panelDef"
                      [rowIndex]="rowIndex"
                      [colIndex]="colIndex"
                    >
                    </select-field>
                  </ng-container>
                  <div class="panel-form__form__body__edit-fields__row__col__actions">
                    <button
                      type="button"
                      mat-icon-button
                      (click)="manageField('remove', { rowIndex, colIndex })"
                      matTooltip="Remove"
                    >
                      <mat-icon svgIcon="cancel"></mat-icon>
                    </button>
                    <button
                      type="button"
                      *ngIf="lastCol"
                      mat-icon-button
                      [disabled]="rowActionDisabled[rowIndex]"
                      (click)="manageField('addInColumn', { rowIndex })"
                      matTooltip="Add"
                    >
                      <mat-icon svgIcon="add_circle"></mat-icon>
                    </button>
                    <button
                      type="button"
                      *ngIf="lastCol"
                      mat-icon-button
                      (click)="manageField('addInNewRow', { rowIndex, colIndex })"
                      matTooltip="Add"
                    >
                      <mat-icon svgIcon="library_add"></mat-icon>
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </form>
</div>
